import { Pipe, type PipeTransform } from '@angular/core';
import {
    toBuildingNameFormat,
    type BuildingNameFormatInput,
} from '@quipex/shared/utils';

@Pipe({
    name: 'qpxBuildingName',
})
export class BuildingNamePipe implements PipeTransform {
    transform(value: BuildingNameFormatInput): string {
        return toBuildingNameFormat(value);
    }
}
